import PropTypes from 'prop-types'

const NotificationIcon = ({ className }: { className: string }) => (
  <svg width={48} height={48} viewBox="0 0 48 48" className={className}>
    <title>{'Builder/ Operation / Smart Notification'}</title>
    <g fill="#1A56DB" fillRule="nonzero">
      <path d="M42 1H22a4 4 0 00-4 4v20a1 1 0 001.581.813L26.32 21H42a4 4 0 004-4V5a4 4 0 00-4-4zM31 15h-6a1 1 0 010-2h6a1 1 0 010 2zm8-6H25a1 1 0 010-2h14a1 1 0 010 2z" />
      <path d="M30 23v16a1 1 0 01-1 1H6a1 1 0 01-1-1V11a1 1 0 011-1h10V5H7a4 4 0 00-4 4v34a4 4 0 004 4h21a4 4 0 004-4V23h-2z" />
    </g>
  </svg>
)

NotificationIcon.displayName = 'NotificationIcon'

NotificationIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

NotificationIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'App Builder'
}

export default NotificationIcon
